/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateDocumenttypeDto } from '../models/work-create-documenttype-dto';
import { WorkDocumenttype } from '../models/work-documenttype';
import { WorkDocumenttypeIdentifierNameEnum } from '../models/work-documenttype-identifier-name-enum';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateDocumenttypeDto } from '../models/work-update-documenttype-dto';

@Injectable({ providedIn: 'root' })
export class WorkDocumenttypesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documenttypesV2ControllerGetAllDropdownOptions()` */
  static readonly DocumenttypesV2ControllerGetAllDropdownOptionsPath = '/v2/documenttypes/dropdown-options';

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documenttypesV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerGetAllDropdownOptions$Response(
    params?: {
      withContainerTypeNames?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumenttypesV2Service.DocumenttypesV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
      rb.query('withContainerTypeNames', params.withContainerTypeNames, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documenttypesV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerGetAllDropdownOptions(
    params?: {
      withContainerTypeNames?: boolean;
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.documenttypesV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `documenttypesV2ControllerGetItemDocumentDropdownOptions()` */
  static readonly DocumenttypesV2ControllerGetItemDocumentDropdownOptionsPath = '/v2/documenttypes/dropdown-options/item-documents';

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documenttypesV2ControllerGetItemDocumentDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerGetItemDocumentDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumenttypesV2Service.DocumenttypesV2ControllerGetItemDocumentDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documenttypesV2ControllerGetItemDocumentDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerGetItemDocumentDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.documenttypesV2ControllerGetItemDocumentDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `documenttypesV2ControllerGetAllDropdownOptionsByContainertypeId()` */
  static readonly DocumenttypesV2ControllerGetAllDropdownOptionsByContainertypeIdPath = '/v2/documenttypes/dropdown-options/{containertypeId}';

  /**
   * Required permissions: documenttypes:read, tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documenttypesV2ControllerGetAllDropdownOptionsByContainertypeId()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerGetAllDropdownOptionsByContainertypeId$Response(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumenttypesV2Service.DocumenttypesV2ControllerGetAllDropdownOptionsByContainertypeIdPath, 'get');
    if (params) {
      rb.path('containertypeId', params.containertypeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:read, tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documenttypesV2ControllerGetAllDropdownOptionsByContainertypeId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerGetAllDropdownOptionsByContainertypeId(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.documenttypesV2ControllerGetAllDropdownOptionsByContainertypeId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `documenttypesV2ControllerFindAll()` */
  static readonly DocumenttypesV2ControllerFindAllPath = '/v2/documenttypes';

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documenttypesV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocumenttype>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumenttypesV2Service.DocumenttypesV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocumenttype>>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documenttypesV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDocumenttype>> {
    return this.documenttypesV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocumenttype>>): Array<WorkDocumenttype> => r.body)
    );
  }

  /** Path part for operation `documenttypesV2ControllerCreate()` */
  static readonly DocumenttypesV2ControllerCreatePath = '/v2/documenttypes';

  /**
   * Required permissions: documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documenttypesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documenttypesV2ControllerCreate$Response(
    params: {
      body: WorkCreateDocumenttypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocumenttype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumenttypesV2Service.DocumenttypesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocumenttype>;
      })
    );
  }

  /**
   * Required permissions: documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documenttypesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documenttypesV2ControllerCreate(
    params: {
      body: WorkCreateDocumenttypeDto
    },
    context?: HttpContext
  ): Observable<WorkDocumenttype> {
    return this.documenttypesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocumenttype>): WorkDocumenttype => r.body)
    );
  }

  /** Path part for operation `documenttypesV2ControllerFindAllPaginated()` */
  static readonly DocumenttypesV2ControllerFindAllPaginatedPath = '/v2/documenttypes/paginated';

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documenttypesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerFindAllPaginated$Response(
    params?: {
      withContainers?: boolean;
      withTasks?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>containertypeId</li>
     * <li>sortableRank</li>
     * <li>itemdocument</li>
     * <li>active</li>
     * <li>relatedStandardtaskId</li>
     * <li>prettyName</li>
     * <li>identifierName</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'sortableRank:ASC' | 'sortableRank:DESC' | 'itemdocument:ASC' | 'itemdocument:DESC' | 'active:ASC' | 'active:DESC' | 'relatedStandardtaskId:ASC' | 'relatedStandardtaskId:DESC' | 'prettyName:ASC' | 'prettyName:DESC' | 'identifierName:ASC' | 'identifierName:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,prettyName,identifierName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>prettyName</li>
     * <li>identifierName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkDocumenttype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumenttypesV2Service.DocumenttypesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('withContainers', params.withContainers, {});
      rb.query('withTasks', params.withTasks, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkDocumenttype>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documenttypesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerFindAllPaginated(
    params?: {
      withContainers?: boolean;
      withTasks?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>containertypeId</li>
     * <li>sortableRank</li>
     * <li>itemdocument</li>
     * <li>active</li>
     * <li>relatedStandardtaskId</li>
     * <li>prettyName</li>
     * <li>identifierName</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'sortableRank:ASC' | 'sortableRank:DESC' | 'itemdocument:ASC' | 'itemdocument:DESC' | 'active:ASC' | 'active:DESC' | 'relatedStandardtaskId:ASC' | 'relatedStandardtaskId:DESC' | 'prettyName:ASC' | 'prettyName:DESC' | 'identifierName:ASC' | 'identifierName:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,prettyName,identifierName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>prettyName</li>
     * <li>identifierName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkDocumenttype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}> {
    return this.documenttypesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkDocumenttype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkDocumenttype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `documenttypesV2ControllerFindById()` */
  static readonly DocumenttypesV2ControllerFindByIdPath = '/v2/documenttypes/{id}';

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documenttypesV2ControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerFindById$Response(
    params: {
      id: number;
      withSubtypes?: boolean;
      withContainers?: boolean;
      withTasks?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocumenttype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumenttypesV2Service.DocumenttypesV2ControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('withSubtypes', params.withSubtypes, {});
      rb.query('withContainers', params.withContainers, {});
      rb.query('withTasks', params.withTasks, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocumenttype>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documenttypesV2ControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerFindById(
    params: {
      id: number;
      withSubtypes?: boolean;
      withContainers?: boolean;
      withTasks?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkDocumenttype> {
    return this.documenttypesV2ControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocumenttype>): WorkDocumenttype => r.body)
    );
  }

  /** Path part for operation `documenttypesV2ControllerDelete()` */
  static readonly DocumenttypesV2ControllerDeletePath = '/v2/documenttypes/{id}';

  /**
   * Required permissions: documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documenttypesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumenttypesV2Service.DocumenttypesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documenttypesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.documenttypesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `documenttypesV2ControllerUpdate()` */
  static readonly DocumenttypesV2ControllerUpdatePath = '/v2/documenttypes/{id}';

  /**
   * Required permissions: documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documenttypesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documenttypesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateDocumenttypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumenttypesV2Service.DocumenttypesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documenttypesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documenttypesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateDocumenttypeDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.documenttypesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `documenttypesV2ControllerFindByIdentifierName()` */
  static readonly DocumenttypesV2ControllerFindByIdentifierNamePath = '/v2/documenttypes/identifierName/{name}';

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documenttypesV2ControllerFindByIdentifierName()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerFindByIdentifierName$Response(
    params: {
      name: WorkDocumenttypeIdentifierNameEnum;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocumenttype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumenttypesV2Service.DocumenttypesV2ControllerFindByIdentifierNamePath, 'get');
    if (params) {
      rb.path('name', params.name, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocumenttype>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documenttypesV2ControllerFindByIdentifierName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documenttypesV2ControllerFindByIdentifierName(
    params: {
      name: WorkDocumenttypeIdentifierNameEnum;
    },
    context?: HttpContext
  ): Observable<WorkDocumenttype> {
    return this.documenttypesV2ControllerFindByIdentifierName$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocumenttype>): WorkDocumenttype => r.body)
    );
  }

}
